import {Injectable} from "@angular/core";
import {AbstractHttpService} from "./AbstractHttpService";
import {Observable} from "rxjs";
import {Projeto} from "../../../domain/Projeto";

@Injectable()
export class ProjetoHttpService  extends AbstractHttpService<Projeto>{
    url = '/api/projeto';
    countAllProjetos(): Observable<number> {
        return this.http.get<number>(this.urlBase + encodeURI(`/count`))
    }
    countAllProjetosAtivos(): Observable<number> {
        return this.http.get<number>(this.urlBase + encodeURI(`/countativo`))
    }
}
